import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Flex } from 'styled-system/jsx';
import DownloadIcon from '@/common/assets/icons/download.svg?react';
import FilesIcon from '@/common/assets/icons/files.svg?react';
import { token } from 'styled-system/tokens';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { downloadHealthCertificationQueryOptions } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadHealthCertification/downloadHealthCertificationQueryOptions';
import useToast from '@/common/store/alert/useToast';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';

const HealthCertificate = () => {
  const { id } = useParams();
  const { showAlert } = useToast();

  const userToken = window.localStorage.getItem('auth-storage');

  const { mutate, isPending } = useMutation({
    ...downloadHealthCertificationQueryOptions(),
    onSuccess: (data: any) => {
      if (data?.path) {
        window.open(
          `${data.path}&token=${JSON.parse(userToken!).state.token}`,
          '_blank',
        );
      }
    },
    onError: () => {
      showAlert({
        description: 'دانلود تصاویر ناموفق بود',
        type: 'error',
      });
    },
  });
  return (
    <CardButton
      title="گواهی سلامت"
      hasArrow={false}
      renderTag={() => (
        <Flex gap="3" alignItems="center">
          {isPending ? (
            <CircularLoading color="colors.purple-3" width="20px" />
          ) : (
            <DownloadIcon stroke={token('colors.purple-2')} />
          )}
          <Typography textStyle="b2" color="purple-2">
            دانلود
          </Typography>
        </Flex>
      )}
      cardProps={{
        boxShadow: 'none',
        onClick: () => {
          isPending ? undefined : mutate({ id: id!, show_image: true });
        },
      }}
      renderIcon={() => <FilesIcon />}
    />
  );
};

export default HealthCertificate;
